import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import { StoreService } from '../store.service';
var CasePracticeClashReportComponent = (function () {
    function CasePracticeClashReportComponent(commonService, apiService, route, router, storeService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.storeService = storeService;
        // 皮肤样式
        this.skinColor = "Cyan";
        this.itemClickEnable = false;
        this.assetsRoute = "../../assets";
    }
    CasePracticeClashReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        var that = this;
        this.isShowReportLv = false;
        this.bestPathBoxShow = false;
        this.analysisBoxShow = false;
        this.starShow = false;
        this.pathClickable = true;
        this.goToListClickedStatus = false;
        this.redoClickedStatus = false;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.practiceId = params["practiceId"];
            _this.exerciseId = params["exerciseId"];
            _this.learningPathId = params["learningPathId"];
            _this.updateExerciseReports();
            _this.apiService
                .ajax({
                type: "get",
                url: "/sr/learningtour",
            })
                .subscribe(function (result) {
                _this.learningTour = result;
            });
            // this.optimum = '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p>' +
            //   '<p class="clashTitle fontBlod">第一阶段  启动会上起纷争</p>' +
            //   '<p class="fontBlod">【销售主管的办公室】</p>' +
            //   '<p><span class="fontLW">主管</span><span>【带着情绪，把脸转向了你】刚刚在会上，你们那些话是什么意思？</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>这个单子你们加班加点了三个多月，挖空心思做了很多方案创新，才从竞争对手里抢下来，很不容易。结果被我们团队当众质疑，我知道你们心里有委屈，一定不痛快。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>对方情绪大，先用同理心表示你的理解。</p></div>'+
            //   '<p><span class="fontLW">主管</span><span>【面色稍稍缓和】你也知道我们两头都难做，那还来跟我们过不去……</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>我并不是想继续来跟您谈谁对谁错，而是看看咱们怎么做，能把这事顺利推进。如果咱们配合不好，我很担心这个项目很难成功。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>强调冲突的影响，让对方了解冲突的影响，也表达你想要解决这个问题的态度。</p></div>'+
            //   '<p><span class="fontLW">主管</span><span>既然都是为了这个项目好，那就讨论问题吧。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>你们答应了客户的一些额外要求（比如，宣传软文、免费体验等等），这么做，相信你们有自己的考量吧？</span></p>'+
            //   '<p><span class="fontLW">主管</span><span>我们能有什么考量。这次的对手财大气粗，这些对他们来讲都是标配。人还能提供鲜花香水邀请函呢。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>理解了。竞品能提供的额外服务很多，如果我们连配合宣传、提前让人体验都不答应的话，你们确实很难拿下客户。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>尽量充分地去澄清原因，不仅能帮助双方想出更好的解决办法，也能赢得对方认同。</p></div>'+
            //   '<p><span class="fontLW">主管</span><span>对啊，可不就是这个道理嘛？我们也不想答应这些麻烦事的。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>我们的难处是在于人手实在太紧张，又遇到旺季。我们会尽我们能做的，也希望跟你们来看看能一起做点什么。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>坦诚分享自己的难处，有助于双方一起想办法。</p></div>'+
            //   '<p><span class="fontLW">主管</span><span>【沉思】那——我觉得有几点我们可以配合你：（开始讨论具体行动……）</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>行，谢谢了。那我总结一下，我们可以做的是：（总结行动中……），会一起配合的是（总结行动中……）。</span></p>'+
            //   '<p><span class="fontLW">主管</span><span>行，我也知道这次额外的需求有点多，辛苦项目的同事了，今天中午我请大家吃个饭。</span></p>'+
            //   '<p class="clashTitle fontBlod">第二阶段  中期再出幺蛾子</p>' +
            //   '<p><span class="fontKS">柯胜</span><span>他先是怪我不安排额外人手，后来给他安排了，又嫌安排的实习生不专业。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>唔，他们是有提过人手的要求，跟我说说你的困难吧。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>下属有抱怨，不用急着给反馈，先来做个澄清。</p></div>'+
            //   '<p><span class="fontKS">柯胜</span><span>老板，你知道的，我们有这么多项目要支持，没办法为一个项目调派这么多人手，我好不容易招了一批实习生过来，实习生的时间很不稳定，我还要花时间培训，设计现场培训指南。但是您看看，A他是什么反应！</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>这确实让人不舒服。那除了人手的问题，还有其他的困难吗？ </span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>【委屈脸】我特别受不了小高“管杀不管埋”的做法。您是知道的，有一些危险项目是有年龄限制的，公司明文规定必须要跟客户提前交代清楚。他呢？什么都不说，害得我们只能在现场硬着头皮劝退，还得临时给一群“高龄”的大老爷们安排其他活动。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>既花了大把时间去招人和培训，还费尽心思地解决突发状况，结果别人还不领情，确实令人不高兴。 </span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>恰到好处的同理，能让对方缓和情绪。</p></div>'+
            //   '<p><span class="fontKS">柯胜</span><span>是啊！！！</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>那回到我们的目的，你觉得我们可以做点什么来改变眼下的状况呢？</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>【不太情愿地沉默了一会】怎么听上去要我让步？</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>那你想想，合作情况僵持不下，对大家都没好处，相反，如果我们主动一些，也许会有改善。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>这里依然使用的是“强调冲突的影响”这一招，在解决冲突的任何阶段，如果对方出现对冲突目标的抗拒，可以使用这个行动来明确目标。</p></div>'+
            //   '<p><span class="fontKS">柯胜</span><span>【神色有些松动，但仍有些不高兴。】</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>打个比方，现场支持的人手问题，你已经尽力了，但受限于资源，客户就是不满意。那我们应该怎么办呢？如果我们彼此合作愉快，他们能给我们提供什么帮助呢？</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>适当地引导思考，有助于发展解决方案。</p></div>'+
            //   '<p><span class="fontKS">柯胜</span><span>【若有所思】嗯——也许他们能提供一些……资源？</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>那我们再想想，小高之所以会惹出那么多“麻烦”，到底是什么原因？</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>【思考中……】他不至于存心搞事，毕竟这项目崩了，受影响最大的其实是他。唉，还是因为他太嫩，跟其他资深的销售比起来，客户管理弱弱的，否则也不会折腾一堆不合理的需求出来。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>没错，小高资历尚浅，而你在处理项目和应对客户上一向表现很出色，如果双方合作顺利，是不是他能帮我们解决资源的难题，而我们能给到一些经验的支持？</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>【沉思片刻，点了点头】有道理，可以试试。</span></p>'+
            //   '<p class="clashTitle fontBlod">第三阶段  三方共同解矛盾</p>' +
            //   '<p><span class="fontWY">高朗</span><span>人都到齐了，您看，我们是不是开始？</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>我知道之前大家有些不愉快。我们都不希望把事情搞砸，否则既不利于项目，更影响到后面的商务，所以来看怎么一起解决。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>开门见山，强调冲突的影响。</p></div>'+
            //   '<p><span class="fontWY">高朗</span><span>您说。</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>好的。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>先分享一下我了解的情况：【总结冲突情况中……】小高、小柯，你们有没有补充？ </span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方分享，充分澄清冲突的原因。</p></div>'+
            //   '<p><span class="fontWY">高朗</span><span>很简单，我希望现场支持能不能别再出状况了，我们好不容易拿下的大单子啊。</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>【翻了个白眼】我希望销售前期能跟客户有更好的沟通，特别是类似年龄限制、场地限制的问题，别自己都搞不清，否则我们跟在后面都忙着帮你救火呢，哪来的工夫管其他的。</span></p>'+
            //   '<p><span class="fontWY">高朗</span><span>【一脸不爽，对着小柯】你这话什么意思？</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>小高，你开始帮了我们很多忙，像客户海报、宣传文章，都是你额外加班做的，为了项目很尽心尽力了；小柯呢，项目多，还要处理各种突发状况，他忙起来是恨不得能劈成两半来用。</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>眼见火药味渐浓，这时候，需要不偏不倚地展现出对双方的同理心。</p></div>'+
            //   '<p><span class="fontWY">高朗</span><span>确实，大家都不容易。</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>这是我们项目团队应该做的。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>大家的工作态度都很认真，不认真就不会起争执。所以，有矛盾没关系，关键是我们能不能一起找出解决的办法来。</span></p>'+
            //   '<p class="fontBlod">高朗、柯胜：说得对。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>问题澄清得差不多了，我们来看看怎么解决。先讨论哪一个？ </span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方专注于解决冲突，才有希望找到化解的方法。</p></div>'+
            //   '<p><span class="fontKS">柯胜</span><span>人手问题吧，正式的项目团队员工没人手，零基础的实习生培训起来又花时间，愁人。</span></p>'+
            //   '<p><span class="fontWY">高朗</span><span>嗨，这不正好有现成的么？今年公司不是刚从体育院校招了一批教练储备么？可以让他们去啊，他们够专业够稳定，能让我们没有后顾之忧，他们自己肯定也愿意多跟着金牌教练学学，一举两得。</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>好主意！</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>渐入佳境了，解决方案进行中……</p></div>'+
            //   '<p><span class="fontBlue">我</span><span>听上去很不错。最让头痛的人手问题看来有点方向了，还有其他的吗？ </span></p>'+
            //   '<p><span class="fontWY">高朗</span><span>呃，我知道之前由于我跟客户没说清楚我们的规定和限制，我经验不足，准备不充分，给你们添了很多麻烦。我以后会多多注意的。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>即使是干过很多年的资深老人，也难免有百密一疏的时候，你开始反思，就是好现象。那么，在这块，你觉得我们能帮你什么吗？ </span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>解决了“事”，如果还能关注“人”，能让双方之后的合作更融洽。</p></div>'+
            //   '<p><span class="fontWY">高朗</span><span>帮我?</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>容我插一句，其实项目做多了，你就会发现客户需求有挺多共同的地方，而且最容易出问题的环节也就那几个。这样吧，我们之前内部有过一些总结文档，我发给你看看，应该对你有点帮助。</span></p>'+
            //   '<p><span class="fontWY">高朗</span><span>真的！？太感谢了！之前我还不分青红皂白地跟你吵架，多谢你不计前嫌。</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>我们也有做得不到位的地方。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>挺不错啊，解决问题的办法是不是都有了？谁来帮我总结一下？</span></p>'+
            //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>最后，进入达成共识的阶段，形成完整的行动计划，让前面的想法都能落地。</p></div>'+
            //   '<p><span class="fontWY">高朗</span><span>现场支持这块，可以请储备新人来做。</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>我会将管理客户预期的文档发给小高，帮助他了解常见的问题。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>嗯，不错。那么这些，咱们具体打算怎么推进？</span></p>'+
            //   '<p><span class="fontWY">高朗</span><span>储备新人我来吧，我跟负责他们的小王很熟，我去搞定。文档就麻烦柯胜发给我。</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>好，我会把后续培训和日程也筹备起来。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>好，看来现在面临的问题都解决了。关于后面的推进，大家还有什么想讨论的吗？</span></p>'+
            //   '<p><span class="fontKS">柯胜</span><span>嗯，其实我建议吧，这个项目的进度会可以频率再高一些，等到之后跟客户磨合稳定了，再慢慢调低。</span></p>'+
            //   '<p><span class="fontWY">高朗</span><span>我同意，我同意，毕竟还是初期，我们之间需要多沟通。</span></p>'+
            //   '<p><span class="fontBlue">我</span><span>好，我也同意，那今天就谢谢两位了。</span></p>';
            // this.optimum = '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p><p class="clashTitle fontBlod">第一阶段  启动会上起纷争</p><p class="fontBlod">【销售主管的办公室】</p> <p><span class="fontLW">主管</span><span>【带着情绪，把脸转向了你】刚刚在会上，你们那些话是什么意思？</span></p><p><span class="fontBlue">我</span><span>这个单子你们加班加点了三个多月，挖空心思做了很多方案创新，才从竞争对手里抢下来，很不容易。结果被我们团队当众质疑，我知道你们心里有委屈，一定不痛快。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>对方情绪大，先用同理心表示你的理解。</p></div><p><span class="fontLW">主管</span><span>【面色稍稍缓和】你也知道我们两头都难做，那还来跟我们过不去……</span></p> <p><span class="fontBlue">我</span><span>我并不是想继续来跟您谈谁对谁错，而是看看咱们怎么做，能把这事顺利推进。如果咱们配合不好，我很担心这个项目很难成功。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>强调冲突的影响，让对方了解冲突的影响，也表达你想要解决这个问题的态度。</p></div> <p><span class="fontLW">主管</span><span>既然都是为了这个项目好，那就讨论问题吧。</span></p> <p><span class="fontBlue">我</span><span>你们答应了客户的一些额外要求（比如，宣传软文、免费体验等等），这么做，相信你们有自己的考量吧？</span></p> <p><span class="fontLW">主管</span><span>我们能有什么考量。这次的对手财大气粗，这些对他们来讲都是标配。人还能提供鲜花香水邀请函呢。</span></p> <p><span class="fontBlue">我</span><span>理解了。竞品能提供的额外服务很多，如果我们连配合宣传、提前让人体验都不答应的话，你们确实很难拿下客户。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>尽量充分地去澄清原因，不仅能帮助双方想出更好的解决办法，也能赢得对方认同。</p></div> <p><span class="fontLW">主管</span><span>对啊，可不就是这个道理嘛？我们也不想答应这些麻烦事的。</span></p> <p><span class="fontBlue">我</span><span>我们的难处是在于人手实在太紧张，又遇到旺季。我们会尽我们能做的，也希望跟你们来看看能一起做点什么。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>坦诚分享自己的难处，有助于双方一起想办法。</p></div><p><span class="fontLW">主管</span><span>【沉思】那——我觉得有几点我们可以配合你：（开始讨论具体行动……）</span></p> <p><span class="fontBlue">我</span><span>行，谢谢了。那我总结一下，我们可以做的是：（总结行动中……），会一起配合的是（总结行动中……）。</span></p> <p><span class="fontLW">主管</span><span>行，我也知道这次额外的需求有点多，辛苦项目的同事了，今天中午我请大家吃个饭。</span></p> <p class="clashTitle fontBlod">第二阶段  中期再出幺蛾子</p> <p><span class="fontKS">柯胜</span><span>他先是怪我不安排额外人手，后来给他安排了，又嫌安排的实习生不专业。</span></p> <p><span class="fontBlue">我</span><span>唔，他们是有提过人手的要求，跟我说说你的困难吧。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>下属有抱怨，不用急着给反馈，先来做个澄清。</p></div> <p><span class="fontKS">柯胜</span><span>老板，你知道的，我们有这么多项目要支持，没办法为一个项目调派这么多人手，我好不容易招了一批实习生过来，实习生的时间很不稳定，我还要花时间培训，设计现场培训指南。但是您看看，A他是什么反应！</span></p> <p><span class="fontBlue">我</span><span>这确实让人不舒服。那除了人手的问题，还有其他的困难吗？ </span></p> <p><span class="fontKS">柯胜</span><span>【委屈脸】我特别受不了小高“管杀不管埋”的做法。您是知道的，有一些危险项目是有年龄限制的，公司明文规定必须要跟客户提前交代清楚。他呢？什么都不说，害得我们只能在现场硬着头皮劝退，还得临时给一群“高龄”的大老爷们安排其他活动。</span></p> <p><span class="fontBlue">我</span><span>既花了大把时间去招人和培训，还费尽心思地解决突发状况，结果别人还不领情，确实令人不高兴。 </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>恰到好处的同理，能让对方缓和情绪。</p></div> <p><span class="fontKS">柯胜</span><span>是啊！！！</span></p> <p><span class="fontBlue">我</span><span>那回到我们的目的，你觉得我们可以做点什么来改变眼下的状况呢？</span></p> <p><span class="fontKS">柯胜</span><span>【不太情愿地沉默了一会】怎么听上去要我让步？</span></p> <p><span class="fontBlue">我</span><span>那你想想，合作情况僵持不下，对大家都没好处，相反，如果我们主动一些，也许会有改善。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>这里依然使用的是“强调冲突的影响”这一招，在解决冲突的任何阶段，如果对方出现对冲突目标的抗拒，可以使用这个行动来明确目标。</p></div> <p><span class="fontKS">柯胜</span><span>【神色有些松动，但仍有些不高兴。】</span></p><p><span class="fontBlue">我</span><span>打个比方，现场支持的人手问题，你已经尽力了，但受限于资源，客户就是不满意。那我们应该怎么办呢？如果我们彼此合作愉快，他们能给我们提供什么帮助呢？</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>适当地引导思考，有助于发展解决方案。</p></div> <p><span class="fontKS">柯胜</span><span>【若有所思】嗯——也许他们能提供一些……资源？</span></p> <p><span class="fontBlue">我</span><span>那我们再想想，小高之所以会惹出那么多“麻烦”，到底是什么原因？</span></p> <p><span class="fontKS">柯胜</span><span>【思考中……】他不至于存心搞事，毕竟这项目崩了，受影响最大的其实是他。唉，还是因为他太嫩，跟其他资深的销售比起来，客户管理弱弱的，否则也不会折腾一堆不合理的需求出来。</span></p> <p><span class="fontBlue">我</span><span>没错，小高资历尚浅，而你在处理项目和应对客户上一向表现很出色，如果双方合作顺利，是不是他能帮我们解决资源的难题，而我们能给到一些经验的支持？</span></p> <p><span class="fontKS">柯胜</span><span>【沉思片刻，点了点头】有道理，可以试试。</span></p> <p class="clashTitle fontBlod">第三阶段  三方共同解矛盾</p> <p><span class="fontWY">高朗</span><span>人都到齐了，您看，我们是不是开始？</span></p> <p><span class="fontBlue">我</span><span>我知道之前大家有些不愉快。我们都不希望把事情搞砸，否则既不利于项目，更影响到后面的商务，所以来看怎么一起解决。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>开门见山，强调冲突的影响。</p></div> <p><span class="fontWY">高朗</span><span>您说。</span></p> <p><span class="fontKS">柯胜</span><span>好的。</span></p> <p><span class="fontBlue">我</span><span>先分享一下我了解的情况：【总结冲突情况中……】小高、小柯，你们有没有补充？ </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方分享，充分澄清冲突的原因。</p></div> <p><span class="fontWY">高朗</span><span>很简单，我希望现场支持能不能别再出状况了，我们好不容易拿下的大单子啊。</span></p> <p><span class="fontKS">柯胜</span><span>【翻了个白眼】我希望销售前期能跟客户有更好的沟通，特别是类似年龄限制、场地限制的问题，别自己都搞不清，否则我们跟在后面都忙着帮你救火呢，哪来的工夫管其他的。</span></p> <p><span class="fontWY">高朗</span><span>【一脸不爽，对着小柯】你这话什么意思？</span></p> <p><span class="fontBlue">我</span><span>小高，你开始帮了我们很多忙，像客户海报、宣传文章，都是你额外加班做的，为了项目很尽心尽力了；小柯呢，项目多，还要处理各种突发状况，他忙起来是恨不得能劈成两半来用。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>眼见火药味渐浓，这时候，需要不偏不倚地展现出对双方的同理心。</p></div> <p><span class="fontWY">高朗</span><span>确实，大家都不容易。</span></p> <p><span class="fontKS">柯胜</span><span>这是我们项目团队应该做的。</span></p> <p><span class="fontBlue">我</span><span>大家的工作态度都很认真，不认真就不会起争执。所以，有矛盾没关系，关键是我们能不能一起找出解决的办法来。</span></p> <p class="fontBlod">高朗、柯胜：说得对。</span></p> <p><span class="fontBlue">我</span><span>问题澄清得差不多了，我们来看看怎么解决。先讨论哪一个？ </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方专注于解决冲突，才有希望找到化解的方法。</p></div> <p><span class="fontKS">柯胜</span><span>人手问题吧，正式的项目团队员工没人手，零基础的实习生培训起来又花时间，愁人。</span></p> <p><span class="fontWY">高朗</span><span>嗨，这不正好有现成的么？今年公司不是刚从体育院校招了一批教练储备么？可以让他们去啊，他们够专业够稳定，能让我们没有后顾之忧，他们自己肯定也愿意多跟着金牌教练学学，一举两得。</span></p> <p><span class="fontKS">柯胜</span><span>好主意！</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>渐入佳境了，解决方案进行中……</p></div> <p><span class="fontBlue">我</span><span>听上去很不错。最让头痛的人手问题看来有点方向了，还有其他的吗？ </span></p> <p><span class="fontWY">高朗</span><span>呃，我知道之前由于我跟客户没说清楚我们的规定和限制，我经验不足，准备不充分，给你们添了很多麻烦。我以后会多多注意的。</span></p> <p><span class="fontBlue">我</span><span>即使是干过很多年的资深老人，也难免有百密一疏的时候，你开始反思，就是好现象。那么，在这块，你觉得我们能帮你什么吗？ </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>解决了“事”，如果还能关注“人”，能让双方之后的合作更融洽。</p></div> <p><span class="fontWY">高朗</span><span>帮我?</span></p> <p><span class="fontKS">柯胜</span><span>容我插一句，其实项目做多了，你就会发现客户需求有挺多共同的地方，而且最容易出问题的环节也就那几个。这样吧，我们之前内部有过一些总结文档，我发给你看看，应该对你有点帮助。</span></p> <p><span class="fontWY">高朗</span><span>真的！？太感谢了！之前我还不分青红皂白地跟你吵架，多谢你不计前嫌。</span></p> <p><span class="fontKS">柯胜</span><span>我们也有做得不到位的地方。</span></p> <p><span class="fontBlue">我</span><span>挺不错啊，解决问题的办法是不是都有了？谁来帮我总结一下？</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>最后，进入达成共识的阶段，形成完整的行动计划，让前面的想法都能落地。</p></div> <p><span class="fontWY">高朗</span><span>现场支持这块，可以请储备新人来做。</span></p> <p><span class="fontKS">柯胜</span><span>我会将管理客户预期的文档发给小高，帮助他了解常见的问题。</span></p> <p><span class="fontBlue">我</span><span>嗯，不错。那么这些，咱们具体打算怎么推进？</span></p> <p><span class="fontWY">高朗</span><span>储备新人我来吧，我跟负责他们的小王很熟，我去搞定。文档就麻烦柯胜发给我。</span></p> <p><span class="fontKS">柯胜</span><span>好，我会把后续培训和日程也筹备起来。</span></p> <p><span class="fontBlue">我</span><span>好，看来现在面临的问题都解决了。关于后面的推进，大家还有什么想讨论的吗？</span></p> <p><span class="fontKS">柯胜</span><span>嗯，其实我建议吧，这个项目的进度会可以频率再高一些，等到之后跟客户磨合稳定了，再慢慢调低。</span></p> <p><span class="fontWY">高朗</span><span>我同意，我同意，毕竟还是初期，我们之间需要多沟通。</span></p> <p><span class="fontBlue">我</span><span>好，我也同意，那今天就谢谢两位了。</span></p>';
            _this.apiService
                .ajax({
                type: "get",
                url: "/api/exerciseTutor/" + _this.exerciseId,
            })
                .subscribe(function (result) {
                _this.tutor = result.tutor;
                _this.optimum = result.optimum;
            });
        });
    };
    CasePracticeClashReportComponent.prototype.updateExerciseReports = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/sr/insideapi/updateExerciseReports?exerciseId=" + this.exerciseId,
        })
            .subscribe(function (result) {
            _this.getKasInfo();
            // this.mockGetKasInfo();
        });
    };
    CasePracticeClashReportComponent.prototype.mockGetKasInfo = function () {
        var result = {
            id: 6613,
            practiceMetaId: 11,
            reports: {
                id: 10138,
                name: "解决冲突",
                type: "exercise",
                kas: [
                    {
                        name: "沟通变革的内容和原因",
                        value: 3,
                        description: "说明变革的商业考虑和预期的益处；强调变革对绩效要求、个人、团队和组织目标所带来的影响。",
                        analysis: "沟通变革的内容和原因是驱动变革的第一步。主管说得清，下属问题少。在这个场景，你自己首先要弄清楚什么在变？为什么要变？对组织、团体和个人有什么收益？然后再传达给下属。然而，在实际的工作场景中，大多数主管要么谈方向、要么喊口号，很难把这三个问题说清楚。<br/><br/>在本情景模拟中，变革的缘由就是客户的流失、营业额的下降。变革的内容对于公司和个人是不同的。对于公司来说，抽调各部门人员成立新项目组，在12个月内开发并上线新产品。对于个人来说，原产品的资源倾斜、合作伙伴、工作内容和优先级都会发生变化。当你明确了变革的这些内容以后，才能在开会的时候清楚表达，会后才不会有下属找你麻烦。<br/><br/>变革才刚开始，变革加速器一是帮助你说清楚变革的关键武器，然而，你对于这一武器的使用并不理想。由于你在会议中没有传达清楚，导致会议后下属不断找你，这样的场景在实际工作中并不陌生。建议在实际工作中，反复训练使用变革加速器一。",
                    },
                    {
                        name: "化解抗拒变革的心态",
                        value: 3,
                        description: "提问以了解他人对变革的想法和感受；接受他人的情况和感受，对他人面对改变时可能产生的失落或恐惧感表示同理心。",
                        analysis: "驱动变革的时候，下属有抗拒的情绪是非常常见的。作为管理者你的责任是尽可能让大部分的成员快速进入适应和拥抱变革阶段。在这个场景中管理者不应该压制、孤立或者无视下属的抗拒而应该通过互动、化解下属在变革中的情绪。变革加速器二能够帮助你在这个场景中化解下属的抗拒情绪，助力变革。<br/><br/>在本情景模拟中，柯胜在说明变革的会议中就表现出抗拒的情绪。在你布置任务后，又通过不交报告来传达抗拒的信息。作为主管，你可以运用变革加速器二，征求各方的反应和感受。让身处困境的柯胜感受到被理解和被重视。运用变革加速器二的时候，不要忘记互动技巧鼓励参与，让下属充分表达他对变革的看法，情绪，情绪背后的原因等等，让他感觉到被尊重和有参与感。如“就像我们上次说的，编程游戏的项目势在必行，这个在团队中我也已经沟通多次。可以说说现在让你把重心放到新项目有什么担心或困难吗？”同时，你也需要仔细聆听，用同理心回应你听到的事实和感受。如“我看到你对A产品新版本的热情，现在这个阶段你一定放不开手。”<br/><br/>你在这个场景中表现的略逊一筹，柯胜在谈话结束后情绪稍有缓解。反思一下在这个情景模拟中，你是否在征求对方反应的时候没有照顾到下属的情绪？建议你在实际的工作过程中运用变革加速器二的时候关注人际互动原则。",
                    },
                    {
                        name: "邀请他人共同发展方案",
                        value: 2,
                        description: "寻求并善用他人的想法、专业知识来实施变革，以促进协同合作，确保成功执行变革计划。",
                        analysis: "驱动变革中邀请他人共同发展方案是变革成功很重要的一步。在实际的工作场景中下属抗拒变革的原因很大程度上是因为他对与变革有一种迷茫和无力感。作为主管，你要做的事情就是帮助下属梳理清楚，哪些是可以掌控的、哪些不可掌控、哪些可以影响，帮助下属重获掌控感。<br/><br/>在本情景模拟中，你可以运用变革加速器二了解柯胜抗拒背后的原因，然后运用变革加速器三，帮助他梳理不可掌控（项目做与不做）、可掌控（对新领域不熟）、可影响（项目风险与收益）的部分。建议你在运用变革加速器三的时候多使用提问的方式鼓励参与帮助柯胜看清局面，对新项目不惆怅。<br/><br/>你和柯胜的谈话并不理想，你没有完全澄清对方的想法和感受，另外在发展方案的时候没有优先让下属参与其中。在实际的工作中，建议你多用提问的方式，不仅可以帮助你充分了解下属的想法同时能够鼓励下属积极参与。继续努力！",
                    },
                    {
                        name: "提供执行面的支持",
                        value: 3,
                        description: "在他人负责实施变革过程中，明确传达方向、指定后续的渐进步骤、提供资源；确认跟踪进度和衡量变革执行成果的方法。",
                        analysis: "驱动变革不是你把任务布置下去就结束了，作为主管，你除了要给出清楚指引之外，还需要对变革的进展做监控和回顾。也让大家了解到过程和结果的一些衡量方法，如果在过程当中发现一些跑偏的地方，你要能够及时地去沟通和纠正，在执行的过程中给予下属支持。<br/><br/>在本情景模拟中，你要明确变革跟进会议的目的，其中要包含的应该有回顾项目进展及提供支持。在下属汇报的过程中，不仅要了解项目的进展，对于进展一般的林薇，你要给予支持帮助她不落后，对于进展缓慢的柯胜，你要邀请他共创改进计划。在这个过程中，不要忘记人际交往原则。<br/><br/>在这个情景模拟中，你在明确会议目的和跟进下属汇报的时候考虑到了监控项目和提供支持，你需要注意的是不要忘记运用人际互动原则，对于顺利推进变革项目会有很有助力哦！",
                    },
                    {
                        name: "奖励变革",
                        value: 5,
                        description: "表扬和奖励作出贡献并采取具体行动支持变革的同事；表达对他人能成功因应变革的信心。",
                        analysis: "变革过程中及时奖励能够有效的激发团队成员的积极性。作为主管，你不仅需要在团队成员做出成绩的时候及时鼓励，同时在团队成员落后的状态下，你也要对他的值得肯定的地方提出表扬。在实际的工作中，大部分主管往往忽略了这一点，在下属做的好的时候一句话夸奖敷衍了事，做的不好的时候不批评就不错了。<br/><br/>在本情景模拟中，你不仅要对，进度良好的魏宇给予表扬，同时，对进度一般的林薇和滞后的柯胜，同样也需要对他们的工作表达认可。注意表扬的时候要运用沟通法则中的维护自尊，加强自信。<br/><br/>你对于下属的鼓励既具体又诚恳，非常棒！希望你能够在实际的驱动变革的场景中很好的展现该关键行为，引领变革。",
                    },
                ],
                totalKa: 16,
            },
            totalQuizCount: 0,
            allQuizFinished: false,
            finishedQuizCount: 0,
            totalExerciseCount: 0,
            allExerciseFinished: true,
            finishedExerciseCount: 1,
            nextExerciseStartTime: null,
        };
        this.practiceMetaId = result.practiceMetaId;
        this.report = result.reports.kas;
        this.reportName = result.reports.name;
        this.finished = result.allExerciseFinished;
        this.getLevelInfo(result.reports);
    };
    CasePracticeClashReportComponent.prototype.getKasInfo = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            // 'url':'/api/practices/'+this.exerciseId+'/'+this.practiceId+'/report'
            url: "/sr/resolvingConflicts/reports/" +
                this.exerciseId +
                "/" +
                this.practiceId,
        })
            .subscribe(function (result) {
            //无报告数据转向列表页
            _this.practiceMetaId = result.practiceMetaId;
            _this.report = result.reports.kas;
            _this.reportName = result.reports.name;
            _this.finished = result.allExerciseFinished;
            _this.getLevelInfo(result.reports);
        });
    };
    CasePracticeClashReportComponent.prototype.getLevelInfo = function (reports) {
        var _this = this;
        var that = this;
        $.ajax({
            url: "/sr/insideapi/getlevel",
            type: "post",
            dataType: "json",
            contentType: "application/json;charset=utf-8",
            data: JSON.stringify(this.getKaList(reports)),
            async: false,
            headers: {
                'transtalen-token': localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                'transtalenuserid': localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
            },
            success: function (result) {
                if (result && result != "") {
                    that.reportKAData = result;
                    that.targetShow = 1;
                }
                else {
                    that.targetShow = 0;
                }
            },
            error: function (er) {
                that.targetShow = 0;
                if (er.status === 401 && Number(er.responseJSON.code) === 106) {
                    that.storeService.notification.notAuthed.next(true);
                }
            },
        });
        if (reports.name == "组织与计划") {
            this.mode = 2;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " bgBlur";
            }
            this.starPicUrl = "/casepracticepando/star2.png";
        }
        else if (reports.name == "影响力") {
            this.mode = 3;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " bgBlur";
            }
            this.starPicUrl = "/casepracticeteam/star_report.png";
        }
        else if (reports.name == "驱动变革") {
            this.mode = 4;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " bgBlur";
            }
            this.starPicUrl = "/casepracticeteam/star_report2.png";
        }
        else if (reports.name == "解决冲突") {
            this.mode = 5;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " cyan";
            }
            this.starPicUrl = "/casepracticeclash/star2.png";
        }
        else {
            this.mode = 1;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " bgBlur";
            }
            this.starPicUrl = "/casepracticeteam/star_report2.png";
        }
        if (that.targetShow === 0) {
            this.isShowReportLv = false;
        }
        else {
            this.isShowReportLv = true;
        }
        setTimeout(function () {
            _this.itemClickEnable = true;
        }, 500);
    };
    CasePracticeClashReportComponent.prototype.ngAfterViewInit = function () {
        var that = this;
        this.commonService.initPage({
            backgroundColor: "white",
        });
        $(document).ready(function () {
            var listenerTimeout = setInterval(function () {
                var bestPathEle = document.getElementById("bestPathBox"), analysisEle = document.getElementById("analysisContent"), tutorEle = document.getElementById("tourReviewBox");
                if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
                    bestPathEle.addEventListener("scroll", that.onBestPathScroll);
                    analysisEle.addEventListener("scroll", that.onAnalysisScroll);
                    tutorEle.addEventListener("scroll", that.onTutorScroll);
                    clearInterval(listenerTimeout);
                }
            }, 500);
        });
    };
    /*
      格式化KA对象方法
       report：传递一个报告对象
     */
    CasePracticeClashReportComponent.prototype.getKaList = function (report) {
        var kaJson = {
            id: report.id,
            name: report.name,
            type: report.type,
            kas: {},
            exercisesId: this.exerciseId,
            questionId: null,
            optionId: null,
        };
        if (window["exercises" + this.exerciseId] != null) {
            var exerciseConfig = window["exercises" + this.exerciseId];
            kaJson.questionId = exerciseConfig.questionId;
            kaJson.optionId = exerciseConfig.optionId;
        }
        if (report) {
            for (var i = 0; i < report.kas.length; i++) {
                var kaItem = report.kas[i];
                if (kaItem) {
                    //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
                    kaJson.kas[kaItem.name] = kaItem.value;
                }
            }
        }
        return kaJson;
    };
    CasePracticeClashReportComponent.prototype.close = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/api/learningpathes/" + this.learningPathId,
        })
            .subscribe(function (result) {
            //转向情景列表
            var link = _this.abilityConfig.getPracticeLinkList(result.name, _this.learningPathId, _this.practiceMetaId);
            if (link.length > 0) {
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            }
        });
    };
    CasePracticeClashReportComponent.prototype.onBestPathScroll = function () {
        var overlay = document.getElementById("bestPathBox");
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
            1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeClashReportComponent.prototype.onAnalysisScroll = function () {
        var overlay = document.getElementById("analysisContent");
        console.log("scroll1");
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
            1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeClashReportComponent.prototype.onTutorScroll = function () {
        var overlay = document.getElementById("tourReviewBox");
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
            1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeClashReportComponent.prototype.subWrapOneOut = function () {
        $("#subWrapOne").fadeOut(function () {
            $("#subWrapTwo").fadeIn();
            $("#btnWrap").fadeIn();
        });
    };
    CasePracticeClashReportComponent.prototype.tourReviewBoxIn = function () {
        $("#tourReviewShade").fadeIn();
        $("#tourReviewBox").fadeIn();
        $(".closeBtn" + this.skinColor).fadeIn();
        this.pathClickable = false;
    };
    CasePracticeClashReportComponent.prototype.tourReviewBoxOut = function () {
        $("#tourReviewShade").fadeOut();
        $("#tourReviewBox").fadeOut();
        $(".closeBtn" + this.skinColor).fadeOut();
        this.pathClickable = true;
    };
    CasePracticeClashReportComponent.prototype.bestPathIn = function () {
        if (!this.pathClickable) {
            return;
        }
        $(".closeBtn" + this.skinColor).fadeIn();
        this.bestPathBoxShow = true;
        $("#shade").fadeIn();
    };
    CasePracticeClashReportComponent.prototype.bestPathOut = function () {
        $(".closeBtn" + this.skinColor).fadeOut();
        this.bestPathBoxShow = false;
        $("#shade").fadeOut();
    };
    CasePracticeClashReportComponent.prototype.redo = function () {
        var _this = this;
        if (!this.pathClickable || this.redoClickedStatus) {
            return;
        }
        else {
            this.redoClickedStatus = true;
        }
        this.apiService
            .ajax({
            type: "get",
            url: "/sr/resolvingConflicts/reset/" + this.exerciseId,
        })
            .subscribe(function (result) {
            // let link = ['case-practice-revolution',this.learningPathId,this.practiceMetaId];
            var link = [
                "case-practice-clash",
                _this.practiceId,
                _this.exerciseId,
                _this.learningPathId,
                _this.practiceMetaId,
            ];
            if (_this.type) {
                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                _this.router.navigate(link);
            }
        });
    };
    CasePracticeClashReportComponent.prototype.analysisBoxIn = function (i) {
        if (!this.itemClickEnable) {
            return false;
        }
        var _this = this;
        this.currentName = this.report[i].name;
        this.currentDescription = this.report[i].description;
        this.currentTotal = this.report[i].value;
        this.currentAnalysis = this.report[i].analysis;
        $("#analysisShade").fadeIn();
        // 滚动到订端
        $("#analysisContent").scrollTop(0);
        // $('#analysisBox').fadeIn();
        this.analysisBoxShow = true;
        $("body").css("overflow-y", "hidden");
        setTimeout(function () {
            _this.starShow = true;
        }, 300);
        this.pathClickable = false;
        document.getElementById("analysisShade").ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById("analysisHead").ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById("closeBtn3").ontouchmove = function (e) {
            e.preventDefault();
        };
    };
    CasePracticeClashReportComponent.prototype.analysisBoxOut = function () {
        $("#analysisShade").fadeOut();
        this.analysisBoxShow = false;
        $("body").css("overflow-y", "scroll");
        this.starShow = false;
        this.pathClickable = true;
    };
    CasePracticeClashReportComponent.prototype.goToList = function () {
        var _this = this;
        if (this.goToListClickedStatus) {
            return;
        }
        else {
            this.goToListClickedStatus = true;
        }
        this.apiService
            .ajax({
            type: "get",
            url: "/api/learningpathes/" + this.learningPathId,
        })
            .subscribe(function (result) {
            //转向情景列表
            var link = _this.abilityConfig.getPracticeLinkList(result.name, _this.learningPathId, _this.practiceMetaId);
            if (link.length > 0) {
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            }
        });
    };
    CasePracticeClashReportComponent.prototype.linkToPostSurvey = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
        })
            .subscribe(function (result) {
            _this.learningPathMetaId = result.data;
            _this.apiService
                .getOrCreateLearningPath(String(_this.learningPathMetaId))
                .subscribe(function (result) {
                _this.learningPath = result;
                if (_this.learningPath.subItems.length == 3) {
                    _this.apiService
                        .ajax({
                        type: "get",
                        url: "/sr/learningtour",
                    })
                        .subscribe(function (result) {
                        _this.learningTour = result;
                        var link = ["survey", _this.learningTour.tour_id, 3, 2];
                        _this.router.navigate(link);
                    });
                }
                else {
                    var link = [
                        "survey",
                        _this.learningPath.id,
                        _this.learningPath.subItems[4].surveyMetaId,
                        1,
                    ];
                    _this.router.navigate(link);
                }
            });
        });
    };
    return CasePracticeClashReportComponent;
}());
export { CasePracticeClashReportComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-clash-report/case-practice-clash-report.component.ts.pre-build-optimizer.js